import React from 'react';
import { Container, Heading, Box, Body, Link } from '@hover/blueprint';
import { Link as GatsbyLink } from 'gatsby';
import { PRICING_FAQ, HELP_CENTER_LINK } from '../../constants';
import { SharedFaq } from '../common';

const FAQ: React.FC = () => (
  <Container
    centerContent
    mt={{ base: 700, tablet: 1000 }}
    maxW="100%"
    mb={1000}
    px={{ base: 500, tablet: '56px' }}
  >
    <Heading
      size={{ base: 500, tablet: 600, desktop: 700 }}
      fontWeight={{ base: 700, desktop: 700 }}
      marginBottom={{ base: 700, desktop: 700 }}
      textAlign="center"
      as="h2"
    >
      Frequently asked questions
    </Heading>
    <Box flexDir="column" alignItems="center" maxW="770px">
      <Heading
        as="p"
        size={{ base: 300, tablet: 500 }}
        isDisplay
        textAlign="center"
        maxW="770px"
      >
        Take a look at our full feature breakdown.
      </Heading>
      <Heading
        as="p"
        size={{ base: 300, tablet: 500 }}
        isDisplay
        textAlign="center"
        marginBottom={{ base: '80px', tablet: '80px' }}
        maxW="770px"
      >
        Still wonder which is best for your team? We’re here to help.
      </Heading>
    </Box>
    <SharedFaq questions={PRICING_FAQ} mb="88px" />
    <Body size={500} fontWeight={300}>
      Still have questions? Never hesitate to contact{' '}
      <Link as={GatsbyLink} to="/contact/" fontWeight={600}>
        Support
      </Link>{' '}
      or visit our{' '}
      <Link as="a" fontWeight={600} href={HELP_CENTER_LINK}>
        Help Center
      </Link>
      .
    </Body>
  </Container>
);

export default FAQ;
